import { Injectable, NgZone } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { SSE } from 'sse.js';

@Injectable({ providedIn: 'root' })
export class SseService {
    private eventSource: SSE;

    constructor(private zone: NgZone, private oauthService: OAuthService) {}

    open<T>(url: string) {
        return new Observable<T>((obs) => {
            this.eventSource = new SSE(url, {
                method: 'GET',
                headers: {
                    Authorization: this.oauthService.authorizationHeader(),
                },
            });

            // register listeners
            this.eventSource.onmessage = (e) => {
                this.zone.run(() => {
                    if (e.data && typeof e.data === 'string' && (e.data as string).startsWith('{')) {
                        obs.next(JSON.parse(e.data) as T);
                    } else {
                        obs.next(e as any);
                    }
                });
            };

            this.eventSource.onerror = (err) => {
                this.zone.run(() => obs.error(err));
            };

            // start the stream
            this.eventSource.stream();
        });
    }

    close() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
        }
    }
}
